import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useAuthContext } from "@src/context/authContext";
import RootAppLayout from "@src/components/layout/RootAppLayout";

const UnauthenticatedApp = () => {
  const { isAuthenticated } = useAuthContext();

  if (isAuthenticated) {
    console.debug("already authenticated");
    return <Navigate to="/dashboard" replace />;
  }

  return (
    // just renders the public route inside this container component
    <RootAppLayout>
      <Outlet />
    </RootAppLayout>
  );
};

export default UnauthenticatedApp;
